import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'equipment-services',
  templateUrl: './equipment-services.component.html',
  styleUrls: ['./equipment-services.component.less'],
})
export class EquipmentServicesComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit(): void {
  }

}
